import React from "react";
import { Card, Tile } from "./shared";
import * as m from "../lib/model";
import { RollUpCompaniesCard } from "./RollUpTerms";
import { AddOnFunding } from "./AddOnFunding";
import { RollUpSummaryCard } from "./RollUpSummary";
import { Layers } from "lucide-react";
import { toast } from "sonner";

// The single roll-up input surface — lives in the Assumptions rail and plugs every roll-up
// assumption (companies, capitalization, add-on funding, back-lever economics) in one place.
export function RollUpPanel({ M, V, setField, patch, consolidated, onRollUp, onViewConsolidated }) {
  const R = m.rollupCfgFor(M);
  const out = m.rollupHeadline(M);
  const fund = m.addonFunding(M);
  const need = m.addonEquityNeed(M);
  const setR = (p) => setField("rollup", { ...R, ...p });
  const attached = !!M.rollup;

  return (
    <div data-testid="rollup-panel">
      <Card title={<span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}><Layers size={13} />Roll-Up — Platform & Add-ons</span>} testid="rollup-panel-head"
        right={attached
          ? (onViewConsolidated && <button className="link-btn lime" onClick={onViewConsolidated} data-testid="rollup-panel-view">View consolidated returns →</button>)
          : <button className="btn btn-sm" onClick={() => { setField("rollup", R); toast.success("Roll-Up attached — a View dropdown now appears on Dashboard, Returns, Assumptions & Sensitivity"); }} data-testid="rollup-panel-attach">Attach Roll-Up to this deal</button>}>
        <div className="grid g4" style={{ marginBottom: 10 }}>
          <Tile label="Consolidated EBITDA" value={m.fmt$(out.totEbitda)} sub={out.sf ? `incl. ${m.fmt$(out.sf.ebitda)} from ${out.sf.count} self-funded add-on${out.sf.count > 1 ? "s" : ""}` : undefined} testid="rp-ebitda" />
          <Tile label="Blended entry multiple" value={m.fmtX(out.blendedEntry)} sub={`exit ${m.fmtX(out.exitMultiple)} · +${m.fmtX(out.multipleArb)} arbitrage`} testid="rp-blended" />
          <Tile label="Total equity ask (LP)" value={m.fmt$(out.live ? out.lpAsk : out.totSponsorEquity)} sub={out.sf ? `${m.fmt$(out.sf.equity)} self-funded excluded` : fund.totFromCF > 0 ? `${m.fmt$(fund.totCalled)} called + ${m.fmt$(fund.totFromCF)} retained cash` : "across every deal"} testid="rp-equity" />
          <Tile label="Add-on cash to raise" value={m.fmt$(need)} sub={fund.refiToPool > 0 ? `${m.fmt$(fund.refiToPool)} from the Yr ${fund.bl.year} back-lever refinance` : m.isRecap(M) ? "war chest in the recap Sources" : "called from committed capital"} tone="go" testid="rp-need" />
        </div>
        <div className="ir-fine">
          Everything below drives the consolidated model: the company table sets EBITDA, entry multiple and acquisition year;
          the capitalization terms apply to every add-on; add-on funding decides how much of each equity check comes from
          retained cash flow versus a capital call.{onRollUp ? " The Roll-Up tab shows the same numbers plus target sourcing and financing." : ""}
        </div>
      </Card>

      {consolidated && <RollUpSummaryCard V={V} onRollUp={onRollUp} />}
      <RollUpCompaniesCard M={M} setField={setField} title="Roll-Up — Platform & Add-on Companies" style={{ marginTop: 12 }} />
      <AddOnFunding M={M} patch={patch} />
    </div>
  );
}
